import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { CSSProperties, ReactNode } from "react";

import { DragHandleProps } from "./types";

export type DraggableItemProps = {
  id: string;
  children: (props: {
    dragHandleProps: DragHandleProps;
    isDragging: boolean;
  }) => ReactNode;
  className?: string;
  fixItemPosition?: boolean;
  disabled?: boolean;
};

export const DraggableItem = ({
  id,
  children,
  className,
  fixItemPosition,
  disabled,
}: DraggableItemProps) => {
  const { setNodeRef, attributes, listeners, transform, isDragging } =
    useDraggable({ id, disabled });

  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
  };

  return (
    <div
      ref={setNodeRef}
      style={fixItemPosition ? undefined : style}
      className={className}
    >
      {children({
        dragHandleProps: { attributes, listeners },
        isDragging,
      })}
    </div>
  );
};
